import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AcceptInvitationStepBase } from '../../shared/accept-invitation-step-base/accept-invitation-step-base';
import { MatDialog } from '@angular/material/dialog';
import { DialogContentComponent } from '../../shared/dialog-content/dialog-content.component';
import { InvitationCommunicationService } from '../../services/invitation-communication.service';
import { DocViewerService } from '../../services/doc-viewer.service';

@Component({
    selector: 'app-certifications',
    templateUrl: './certifications.component.html',
    styleUrl: './certifications.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CertificationsComponent extends AcceptInvitationStepBase<any> {
  private readonly dialog = inject(MatDialog);
  private readonly communicationService = inject(InvitationCommunicationService);
  private readonly docViewerService = inject(DocViewerService);
  private readonly invitationCommunicationService = inject(InvitationCommunicationService);

  // Storage key for local storage
  protected override readonly storageKey = 'certificationsForm';
  
  public override readonly nextUrl = null;
  public override readonly previousUrl = '../link-bank-account';
  
  // Form definition with checkbox as only field
  public override readonly form = inject(FormBuilder).group({
    agreedToTerms: [false, Validators.requiredTrue]
  });

  /**
   * Override of the continue method from the base class
   * If the form is valid, persists the data and calls the submitApplication method
   * of the parent component through the communication service
   */
  public override continue(): Promise<void> {
    if (this.form.valid) {
      // Send the signal through the communication service
      this.communicationService.triggerSubmitApplication();
    }
    return Promise.resolve();
  }

  /**
   * Open the privacy notice in a dialog
   */
  public openPrivacyNotice(): void {
    this.docViewerService.openPdf("/assets/docs/MSB_U.S._Consumer_Privacy_Notice_-_July_2025.pdf", "Privacy Notice");
  }

  /**
   * Get the invitation role
   * 
   * @return the invitation role as a string
   */
  public get role(): string {
    return this.invitationCommunicationService.role;
  }
}
